import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Show first tab by default
    this.switch({ target: this.tabTargets[0] })
  }

  switch(event) {
    event.preventDefault()
    
    // Remove active states
    this.tabTargets.forEach(tab => {
      tab.classList.remove("border-[#FF6B00]", "text-black")
      tab.classList.add("border-transparent", "text-gray-600")
    })
    
    this.panelTargets.forEach(panel => panel.classList.add("hidden"))
    
    // Add active states
    const tab = event.target
    const panel = this.element.querySelector(tab.getAttribute("href"))
    
    tab.classList.remove("border-transparent", "text-gray-600")
    tab.classList.add("border-[#FF6B00]", "text-black")
    panel.classList.remove("hidden")
  }
}